export enum Events {
  REQUEST_FRIENDSHIP = 'Request friendship',
  REMOVE_FRIENDSHIP = 'Remove friendship',
  CANCEL_FRIENDSHIP_REQUEST = 'Cancel friendship request',
  ACCEPT_FRIENDSHIP_REQUEST = 'Accept friendship request',
  REJECT_FRIENDSHIP_REQUEST = 'Reject friendship request',
  SHARE_PROFILE = 'Share profile',
  VIEW_MORE_ABOUT_PROFILE = 'View more about profile',
  GO_TO_WORLD = 'Go to world',
  GET_A_NAME = 'Get a name',
  ACTIVATE_WORLD = 'Activate world',
  COPY_WALLET_ADDRESS = 'Copy wallet address',
  CLICK_BUTTON = 'Click button'
}

export enum ShareType {
  COPY_LINK = 'Copy link',
  TWITTER = 'Twitter',
  X = 'X',
  MOBILE_SHARE = 'Mobile share'
}
